import React, { useState } from 'react';
import Button from '@material-ui/core/Button';
import BoldIcon from '@material-ui/icons/FormatBold';
import ItalicIcon from '@material-ui/icons/FormatItalic';
import UnderlinedIcon from '@material-ui/icons/FormatUnderlined';
import OrderedListIcon from '@material-ui/icons/FormatListNumbered';
import UnorderedListIcon from '@material-ui/icons/FormatListBulleted';
import FormatSizeIcon from '@material-ui/icons/FormatSize';
import ColorIcon from '@material-ui/icons/FormatColorText';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { makeStyles } from '@material-ui/styles';
import noneImg from '../../images/none.png';
import colors from './colorDefinitins';

const useStyles = makeStyles(theme => ({
  btnGroup: {
    background: '#fff',
  },
  divider: {
    display: 'inline-block',
    width: 7,
    heigth: 20,
  },
  colorTable: {
    width: 80,
    display: 'flex',
    flexWrap: 'wrap',
    borderRight: '1px solid #fff',
    borderTop: '1px solid #fff',
    margin: '0 0.5em',
    '& > div': {
      width: '33.333%',
      paddingBottom: '33.333%',
      boxSizing: 'border-box',
      borderBottom: '1px solid #fff',
      borderLeft: '1px solid #fff',
      cursor: 'pointer',
    }
  }
}));

const INLINE = 'INLINE';
const BLOCK  = 'BLOCK';
const COLOR  = 'COLOR';
let counter = 0;

function DraftToolbar (props) {
  const classes = useStyles();
  const [formatAnchor, setFormatAnchor] = useState(null);
  const [colorAnchor, setColorAnchor ] = useState(null);

  const onFormatShow = (ev) => {
    setFormatAnchor(ev.currentTarget);
  }

  const onFormatClose = () => {
    setFormatAnchor(null);
  }

  const onColorShow = (ev) => {
    setColorAnchor(ev.currentTarget);
  }

  const onColorClose = () => {
    setColorAnchor(null);
  }

  const onColorChange = (style) => {
    props.setStyleChange({ type: COLOR, style, counter: counter++ })
    onColorClose();
  }

 
  const changeStyle = (type, style) => {
    props.setStyleChange({ type: type, style, counter: counter++ });
    if (type === BLOCK) onFormatClose();
  }

  const createColorTable = () => {
    const colorTable = colors.map(color => {
      const name = Object.keys(color)[0];
      if(color[name] !== 'none') {
        return <div key={name} style={{backgroundColor: color[name]}} onClick={() => onColorChange(name)}></div>
      } else {
        return <div key={name} style={{background: `url('${noneImg}') no-repeat center center / cover`}} onClick={() => onColorChange(name)}></div>
      }
    });
    return <div className={classes.colorTable}>{colorTable}</div>
  }

  return(
    <div className={classes.toolbar}>
    <ButtonGroup size="small" className={classes.btnGroup} onClick={onFormatShow}>
      <Button><FormatSizeIcon /></Button>
    </ButtonGroup>
    <Menu
      id="block-style"
      anchorEl={formatAnchor}
      keepMounted
      open={Boolean(formatAnchor)}
      onClose={onFormatClose}
    >
      <MenuItem onClick={() => changeStyle(BLOCK, 'unstylled')}>Paragraf</MenuItem>
      <MenuItem onClick={() => changeStyle(BLOCK, 'header-one')}>Tytuł</MenuItem>
      <MenuItem onClick={() => changeStyle(BLOCK, 'header-two')}>Nagłówek 1</MenuItem>
      <MenuItem onClick={() => changeStyle(BLOCK, 'header-three')}>Nagłówek 2</MenuItem>
      <MenuItem onClick={() => changeStyle(BLOCK, 'header-five')}>Nagłówek 3</MenuItem>
    </Menu>
    <div className={classes.divider} />
    <ButtonGroup size="small" className={classes.btnGroup}>
      <Button onClick={() => changeStyle(INLINE, 'BOLD')}><BoldIcon /></Button>
      <Button onClick={() => changeStyle(INLINE, 'ITALIC')}><ItalicIcon /></Button>
      <Button onClick={() => changeStyle(INLINE, 'UNDERLINE')}><UnderlinedIcon /></Button>
    </ButtonGroup>
    <div className={classes.divider} />
    <ButtonGroup size="small" className={classes.btnGroup}>
      <Button onClick={() => changeStyle(BLOCK, 'ordered-list-item')}><OrderedListIcon /></Button>
      <Button onClick={() => changeStyle(BLOCK, 'unordered-list-item')}><UnorderedListIcon /></Button>
    </ButtonGroup>
    <div className={classes.divider} />
    <ButtonGroup size="small" className={classes.btnGroup}>
      <Button onClick={onColorShow} aria-controls="color-picker" aria-haspopup="true"><ColorIcon /></Button>
    </ButtonGroup>
    <Menu
      id="color-picker"
      anchorEl={colorAnchor}
      keepMounted
      open={Boolean(colorAnchor)}
      onClose={onColorClose}
    >
      {createColorTable()}
    </Menu>
    </div>
  );
}

export default DraftToolbar;
